import { func_validation } from "functions";
import { useSelector } from "react-redux";

export function useCustomSelector(reducerName) {
    return useSelector(func_validation.getSelectorFunc(reducerName));
}